(() => {
  const config = window.RA_JAPAN_LOCALE || {};
  const version = 'ra-japan-locale-v1';
  const languageKey = 'ra-language-choice';
  const attemptKey = 'ra-japanese-locale-attempt';

  if (window.__raJapanLocaleVersion === version) return;
  window.__raJapanLocaleVersion = version;

  const readSession = (key) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_) {
      return null;
    }
  };

  const writeSession = (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_) {
      document.documentElement.setAttribute('data-ra-locale-storage', 'unavailable');
    }
  };

  const currentLanguage = () => (
    String(document.documentElement.lang || config.language || '')
      .toLowerCase()
      .split('-')[0]
  );

  const recordLanguageChoice = (event) => {
    const select = event.target?.closest?.('select[name="language_code"]');
    if (!select) return;
    writeSession(languageKey, select.value);
  };

  const submitJapaneseLocale = () => {
    const form = document.createElement('form');
    const currentUrl = new URL(window.location.href);
    const returnTo = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;

    form.method = 'post';
    form.action = config.localizationUrl || '/localization';
    form.hidden = true;

    const values = {
      _method: 'put',
      language_code: 'ja',
      return_to: returnTo
    };

    for (const [name, value] of Object.entries(values)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    writeSession(languageKey, 'ja');
    writeSession(attemptKey, JSON.stringify({
      path: currentUrl.pathname,
      timestamp: Date.now()
    }));
    document.documentElement.setAttribute('data-ra-locale-action', 'switching-to-ja');
    document.body.appendChild(form);
    form.submit();
  };

  const shouldForceJapanese = () => {
    if (config.designMode) return false;
    if (window.location.hostname !== config.host) return false;
    if (currentLanguage() === 'ja') return false;
    if (readSession(languageKey) === 'en') return false;

    const rawAttempt = readSession(attemptKey);
    if (!rawAttempt) return true;

    try {
      const attempt = JSON.parse(rawAttempt);
      return attempt.path !== window.location.pathname || Date.now() - attempt.timestamp > 10000;
    } catch (_) {
      return true;
    }
  };

  document.addEventListener('change', recordLanguageChoice, true);

  if (currentLanguage() === 'ja') {
    writeSession(languageKey, 'ja');
    document.documentElement.setAttribute('data-ra-locale-continuity', 'ja');
    return;
  }

  if (readSession(languageKey) === 'en') {
    document.documentElement.setAttribute('data-ra-locale-continuity', 'explicit-en');
    return;
  }

  if (shouldForceJapanese()) {
    submitJapaneseLocale();
    return;
  }

  document.documentElement.setAttribute('data-ra-locale-continuity', 'unchanged');
})();
